import { useContext, useEffect, useState } from 'react'

import {
  Box,
  Button,
  Icon,
  Input,
  Table,
  TableHeader,
  TablePagination,
  Text,
} from '@fairfashion/design-system'

import { useDebounceValue } from '../../hooks/useDebounceValue'

import { AuditItemsContext, AuditItemsProvider } from './audit-items.context'
import * as Styles from './audit-items.styles'

const AuditItemsComp = () => {
  const [page, setPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [search, setSearch] = useState('')

  const { items, itemsCount, actions } = useContext(AuditItemsContext)

  const debouncedSearch = useDebounceValue(search, 500)

  useEffect(() => {
    actions.fetchItems(page, itemsPerPage, debouncedSearch)
  }, [page, itemsPerPage, debouncedSearch])

  useEffect(() => {
    setPage(1)
  }, [debouncedSearch])

  const headers: TableHeader[] = [
    {
      key: 'code',
      label: 'Código do item',
    },
    {
      key: 'description',
      label: 'Descrição',
    },
    {
      key: 'client.name',
      label: 'Cliente',
    },
    {
      key: 'invoice.code',
      label: 'Código da Nota',
      width: '200px',
      align: 'center',
    },
    {
      key: 'invoice.createDate',
      label: 'Data de emissão',
      width: '200px',
      align: 'center',
      customRender: (row) => (
        <Box width="100%" justifyContent="center">
          <Text>
            {row.invoice?.createDate
              ? new Date(row.invoice.createDate).toLocaleDateString()
              : ''}
          </Text>
        </Box>
      ),
    },
    {
      key: 'details',
      label: 'Detalhes',
      align: 'center',
      width: '60px',
      customRender: (row) => (
        <Box width="100%" justifyContent="center">
          <a href={`/audit/${row.id}`}>
            <Button variant="text" padding="0">
              <Icon name="file_search" size={24} color="secondary" />
            </Button>
          </a>
        </Box>
      ),
    },
  ]

  return (
    <Box width="100%" direction="column" padding={3} gap={3}>
      <Styles.Title>Auditoria</Styles.Title>
      <Text>Busque pelo item, nota fiscal ou empresa cliente</Text>

      <Table
        headers={headers}
        data={items}
        header={
          <Box width="100%" paddingY={2} paddingX={2}>
            <Box width="500px" maxWidth="100%">
              <Input
                placeholder="Busque pelo item, nota fiscal ou cliente"
                adornmentPosition="left"
                adornment={<Icon name="search" color="grey_2" />}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </Box>
          </Box>
        }
        footer={
          <Box width="100%" paddingY={2} paddingX={2} justifyContent="center">
            <TablePagination
              total={itemsCount}
              current={page}
              onChange={(_page) => setPage(_page)}
              itemsPerPage={itemsPerPage}
              onChangeItemsPerPage={(_itemsPerPage) =>
                setItemsPerPage(_itemsPerPage)
              }
            />
          </Box>
        }
      />
    </Box>
  )
}

export const AuditItems = () => {
  return (
    <AuditItemsProvider>
      <AuditItemsComp />
    </AuditItemsProvider>
  )
}
